<template>
    <div>
        <template v-if="paymentRecordLoading">
            <PageSpinner />
        </template>

        <template v-else-if="paymentRecordErr">
            <p class="text--sm text-error-400">
                Error fetching payment history...
            </p>
        </template>

        <template v-else>
            <template v-if="paymentHistory.length">
                <CustomTable 
                    :columns="paymentHistoryHeaders" 
                    :data="paymentHistory" 
                    :is-checkbox="false"
                    :pointer="false"
                    table-type="striped"
                >
                    <template #rows="data">
                        <td>{{ $format_date(data.createdAt) || "-" }}</td>
                        <td class="text--capitalize">
                            {{ data.items[0].service || "-" }}
                        </td>
                        <td> {{ $country.getSymbol(data.currency, 'currency') || 'NGN' }}{{ $format_amount(data.items[0].amount, 2) || 0.00 }}</td>
                        <td>
                            <Status type="subscription_payments" :value="data.status" />
                        </td>
                        <td>
                            <div class="flex align-items-center pointer" @click="$emit('open-invoice-modal', data)">
                                <IconSvg name="show"  width="16px" />
                                <span class="text--xs ml--5 text-gray-800">View receipt</span>
                            </div>
                        </td>
                    </template>
                </CustomTable>

                <template v-if="pageData.totalPages > 1">
                    <Pagination 
                        :pagination-data="pageData" 
                        class="mt--20 mb--20" 
                        :route-change="false"
                        @page-change="fetchPaymentRecords" 
                    />
                </template>
            </template>

            <template v-else>
                <p class="text--sm">
                    You have no billing history.
                </p>
            </template>
        </template>
    </div>
</template>

<script>
import {
    CustomTable,
    IconSvg,
    PageSpinner,
    Pagination,
    Status,
} from "@/components/ui/index";
import { paymentHistoryHeaders } from "@/utils/dummy";

export default {
    name: "PaymentHistory",

    components: {
        CustomTable,
        IconSvg,
        PageSpinner,
        Pagination,
        Status,
    },

    emits: ["open-invoice-modal"],

    data() {
        return {
            paymentHistoryHeaders,
            paymentRecordLoading: false,
            paymentRecordErr: false,
            paymentReceipt: {},
        };
    },

    computed: {
        accountPlan() {
            return this.$store.getters["subscription/subscriptionInfo"]?.plan || "free";
        },

        paymentHistory() {
            return this.$store.getters["subscription/paymentHistory"];
        },

        pageData() {
            return this.$store.getters["subscription/pageData"];
        },

        profile() {
            return this.$store.getters["auth/profile"];
        },
    },

    async mounted() {
        if (!this.paymentHistory.length) {
            await this.fetchPaymentRecords({ refresh: true });
        }
    },

    methods: {
        async fetchPaymentRecords(params) {            
            try {
                let payload = {};
                
                if (typeof params === "number") {
                    payload.page = params;
                    payload.refresh = true;
                } else {
                    payload = { 
                        ...params, 
                    };
                }
                
                this.paymentRecordErr = false;
                this.paymentRecordLoading = true;

                await this.$store.dispatch("subscription/fetchPaymentRecords", { 
                    refresh: payload.refresh, 
                    params: {
                        page: payload?.page || 1,
                    },
                });
            } catch (error) {                
                this.paymentRecordErr = true;
            } finally {
                this.paymentRecordLoading = false;
            }
        },
    },
};
</script>